import ISystemStatusVm from "./ISystemStatusVm"
import IContextBaseVm from "./../Shared/IContextBaseVm"
import IIdentityProviderRealmVm from "./../Shared/IIdentityProviderRealmVm"

import * as IContextBaseVmInstance from "./../Shared/IContextBaseVm"
import * as ISystemStatusVmInstance from "./ISystemStatusVm"

export default interface IHomeVm extends IContextBaseVm {
    identityProviderRealms: IIdentityProviderRealmVm[]
    status: ISystemStatusVm
}

export const empty = (enableIteration: boolean = true): IHomeVm => {
	return {
		...IContextBaseVmInstance.empty(),
		identityProviderRealms: [] as IIdentityProviderRealmVm[],
		status: ISystemStatusVmInstance.empty()
	} as IHomeVm
}